import { css } from 'lit';
const ConfigVSL = {
	minSpeedLimit: 40,
	maxSpeedLimit: 75,
	speedLimitIncrement: 5,
	standbyText: '..',
	table: {
		defaultColumns: ['number', 'name', 'direction', 'route', 'mileMarker', 'status'],
	},
};

export default ConfigVSL;
